import axios from "axios";
import { ITracker, TrackerStats } from "../interfaces/tracker";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000";

// Get all trackers
export const getTrackers = async (params?: {
    project?: string;
    q?: string;
    active?: boolean;
    ownerId?: string;  // For admin to fetch specific user's trackers
}) => {
    const token = localStorage.getItem("token");
    const searchParams = new URLSearchParams();
    
    if (params?.project) searchParams.append("project", params.project);
    if (params?.q) searchParams.append("q", params.q);
    if (params?.active !== undefined) searchParams.append("active", String(params.active));
    if (params?.ownerId) searchParams.append("ownerId", params.ownerId);
    
    const url = `${API_BASE}/trackers${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    
    const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Create a new tracker
export const createTracker = async (tracker: Partial<ITracker>) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_BASE}/trackers`, tracker, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get a specific tracker
export const getTracker = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/trackers/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Update a tracker
export const updateTracker = async (id: string, tracker: Partial<ITracker>) => {
    const token = localStorage.getItem("token");
    const response = await axios.put(`${API_BASE}/trackers/${id}`, tracker, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Delete a tracker
export const deleteTracker = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.delete(`${API_BASE}/trackers/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Toggle tracker active status
export const toggleTracker = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.patch(`${API_BASE}/trackers/${id}/toggle`, {}, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Simulate tracker execution
export const simulateTracker = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_BASE}/trackers/${id}/simulate`, {}, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get tracker statistics
export const getTrackerStats = async (): Promise<TrackerStats> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/trackers/stats/overview`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get tracker tags
export const getTrackerTags = async (): Promise<string[]> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/trackers/tags`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};